"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "attendeeCameraStatusChanged", {
  enumerable: true,
  get: function get() {
    return _attendeeCameraStatusChanged["default"];
  }
});
var _attendeeCameraStatusChanged = _interopRequireDefault(require("./attendeeCameraStatusChanged"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }